import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  Container,
  Typography,
  TableContainer,
  TablePagination
} from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { ToastContainer, toast } from 'material-react-toastify';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../components/_dashboard/user';
import Label from '../components/Label';
import Loader from '../components/_dashboard/user/Loader';
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  buttonS: {
    padding: '10px 20px',
    fontFamily: 'Oregano, cursive',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 600,
    background: '#f58081',
    letterSpacing: 1,
    borderRadius: 5,
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)',
    opacity: 1,
    transition: 'all 0.1s ease-in',
    border: 'none',
    '&:hover': {
      opacity: 0.9
    }
  }
}));

const TABLE_HEAD = [
  { id: 'children', label: 'enfant' },
  { id: 'created_at', label: 'crééà' },
  { id: 'parent', label: 'parent' },
  { id: 'class', label: 'classe' },
  { id: 'gender', label: 'genre' },
  { id: 'status', label: 'statut' },
  { id: 'action', label: 'action' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.username.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({}));

export default function ChildrenList() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [children, setChildren] = useState([]);
  const [checked, setChecked] = useState(null);
  const [checkedAll, setCheckedAll] = useState(false);
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [ispayment, setIspayment] = useState(false);
  const [select, setSelect] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = children.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - children.length) : 0;

  const filteredUsers = applySortFilter(children, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  // GET all hildren
  const retrieveChildren = async () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: `${API_ENDPOINT}/api/child-register/`,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  };

  useEffect(async () => {
    setIsLoading(true);
    const allChildren = await retrieveChildren();
    console.log('children***', allChildren);
    if (allChildren) {
      setChildren(allChildren);
      setIsLoading(false);
    }
  }, []);

  const deactivate = (ID) => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios({
      method: 'PUT',
      url: `${API_ENDPOINT}/api/deactivate-child-from-admin/`,
      headers: { Authorization: `Bearer ${token}` },
      data: { id: `${ID}` }
    })
      .then((res) => {
        console.log('Deactivate user ID -->', ID);
        setChildren(
          children.map((c) => {
            if (c.id === ID) {
              c.is_active = false;
            }
            return c;
          })
        );
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const activate = (ID) => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios({
      method: 'PUT',
      url: `${API_ENDPOINT}/api/activate-child-from-admin/`,
      headers: { Authorization: `Bearer ${token}` },
      data: { id: `${ID}` }
    })
      .then((res) => {
        console.log('activate user ID -->', ID);
        setChildren(
          children.map((c) => {
            if (c.id === ID) {
              c.is_active = true;
            }
            return c;
          })
        );
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const toggleCheck = (inputName) => {
    setChecked((prevState) => {
      const newState = { ...prevState };
      newState[inputName] = !prevState[inputName];
      return newState;
    });
  };

  const selectAll = (value) => {
    setCheckedAll(value);
    setChecked((prevState) => {
      const newState = { ...prevState };
      Object.keys(newState).forEach((inputName) => (newState[inputName] = value));
      return newState;
    });
  };

  const kk = async () => {
    const allChildren = await retrieveChildren();
    const form = [];
    for (let i = 0; i < allChildren.length; i += 1) {
      form.push(allChildren[i].id);
    }
    const initialState = form.reduce((o, key) => ({ ...o, [key]: false }), {});
    setChecked(initialState);
  };

  useEffect(() => {
    kk();
    console.log('jjjjj=>', checked);
  }, []);

  useEffect(() => {
    if (checked != null) {
      console.log('uuuuu=>', checked);
      let allChecked = true;
      Object.keys(checked).forEach((inputName) => {
        if (checked[inputName] === false) {
          allChecked = false;
        }
      });
      if (allChecked) {
        setCheckedAll(true);
      } else {
        setCheckedAll(false);
      }
    }
  }, [checked]);

  useEffect(() => {
    if (checked != null) {
      let allChecked = false;
      Object.keys(checked).forEach((inputName) => {
        if (checked[inputName] === true) {
          allChecked = true;
        }
      });
      if (allChecked) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    }
  }, [checked]);

  const notifySuccess = (message) => {
    toast.success(message, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };

  const sel = () => {
    console.log('sellll==>', checked);
    const formData = new FormData();
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem('access');
    const listID = [];
    Object.keys(checked).forEach((inputName) => {
      if (checked[inputName] === true) {
        listID.push(inputName);
      }
    });
    listID.forEach((item) => formData.append('liste', item));
    console.log('select===>', select);
    formData.append('abonnement', select);
    axios({
      method: 'POST',
      url: `${API_ENDPOINT}/api/payment_request_by_creche/`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
      data: formData
    })
      .then((res) => {
        console.log('response', res);
        notifySuccess('Payment registered successfully');
        selectAll(false);
        setSelect(null);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const togglePayment = () => {
    setIspayment(!ispayment);
    if (ispayment) {
      // selectAll(false);
      setSelect(null);
    }
  };

  return (
    <Page title={t('Listenfants')}>
      <Container>
        <Loader load={isLoading || checked === null} />
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('Listenfants')}
          </Typography>
        </Stack>
        <ToastContainer />
        <Card>
          <UserListToolbar
            numSelected={visible}
            filterName={filterName}
            onFilterName={handleFilterByName}
            holder={`${t('search')}...`}
            click={togglePayment}
            click1={sel}
            btnName={t('paiement')}
            isPayment={ispayment}
            select={select}
            setSelect={setSelect}
          />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={children.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  checkFunc={(event) => selectAll(event.target.checked)}
                  check={checkedAll}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const isItemSelected = selected.indexOf(row.username) !== -1;
                      const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
                      const pic = `${API_ENDPOINT}${row.photo}`;

                      return (
                        <TableRow
                          hover
                          key={row.id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <StyledTableCell
                            component="th"
                            scope="row"
                            padding="none"
                            style={{
                              paddingLeft: document.body.dir === 'rtl' ? 0 : 20,
                              paddingRight: document.body.dir === 'rtl' ? 20 : 0
                            }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Checkbox
                                onChange={() => toggleCheck(row.id)}
                                checked={checked !== null && checked[row.id]}
                                sx={{
                                  color: '#f78181',
                                  '&.Mui-checked': {
                                    color: '#f78181'
                                  }
                                }}
                              />
                              <Avatar alt={row.username} src={pic} />
                              <Typography variant="subtitle2" noWrap>
                                {row.username}
                              </Typography>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>{row.username}</StyledTableCell>
                          <StyledTableCell>{row.parents}</StyledTableCell>
                          <StyledTableCell>{row.classes}</StyledTableCell>
                          <StyledTableCell>{t(row.genre)}</StyledTableCell>
                          <StyledTableCell>
                            <Label variant="ghost" color={row.is_active ? 'success' : 'error'}>
                              {row.is_active ? t('actif') : t('banni')}
                            </Label>
                          </StyledTableCell>
                          <StyledTableCell style={{ display: 'flex' }}>
                            <IconButton
                              onClick={() => activate(row.id)}
                              size="small"
                              aria-label="upload picture"
                              component="span"
                            >
                              <CheckIcon color="success" />
                            </IconButton>
                            <IconButton
                              size="small"
                              aria-label="upload picture"
                              component="span"
                              onClick={() => deactivate(row.id)}
                            >
                              <CloseIcon style={{ color: 'red' }} />
                            </IconButton>
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            component="div"
            count={children.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
